
const panelTypePrefix = (panelType = 'pp') => panelType !== 'tp' ? '/panel-player' : '/panel-trainer';

export const routeCommon = {
    'common.chats':         (panelType) => `${panelTypePrefix(panelType)}/messages`,
    'common.chat.messages': (panelType, chatId = ':chatId') => `${panelTypePrefix(panelType)}/messages/${chatId}`,
    'common.notifications': (panelType) => `${panelTypePrefix(panelType)}/notifications`,
    'common.bugReport':     (panelType) => `${panelTypePrefix(panelType)}/bug-report`,
}